"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _reactReduxI18n = require("react-redux-i18n");

var _validators = require("./validators");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var AbstractFormComponent = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(AbstractFormComponent, _React$Component);

  var _super = _createSuper(AbstractFormComponent);

  function AbstractFormComponent(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, AbstractFormComponent);
    _this = _super.call(this, props, context);

    if (_this.getFormData === undefined) {
      throw new TypeError("Class \"".concat(_this.constructor.name, "\" must implement \"getFormData\""));
    }

    if (_this.getFormValidators === undefined) {
      throw new TypeError("Class \"".concat(_this.constructor.name, "\" must implement \"getFormValidators\""));
    }

    if (_this.handleSubmitCallback === undefined) {
      throw new TypeError("Class \"".concat(_this.constructor.name, "\" must implement \"handleSubmitCallback\""));
    }

    _this.state = {
      submitted: false,
      submitting: false,
      loading: true,
      formData: _this.getFormData(),
      fieldErrors: {}
    };
    _this.formValidators = _this.getFormValidators();
    _this.reset = _this.reset.bind((0, _assertThisInitialized2.default)(_this));
    _this.validateAllFields = _this.validateAllFields.bind((0, _assertThisInitialized2.default)(_this));
    _this.validateField = _this.validateField.bind((0, _assertThisInitialized2.default)(_this));
    _this.isFormValid = _this.isFormValid.bind((0, _assertThisInitialized2.default)(_this));
    _this.isFormInvalid = _this.isFormInvalid.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChangeCallback = _this.handleChangeCallback.bind((0, _assertThisInitialized2.default)(_this));
    _this.isOnError = _this.isOnError.bind((0, _assertThisInitialized2.default)(_this));
    _this.helperText = _this.helperText.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCancel = _this.handleCancel.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSubmit = _this.handleSubmit.bind((0, _assertThisInitialized2.default)(_this));
    _this.getFormData = _this.getFormData.bind((0, _assertThisInitialized2.default)(_this));
    _this.getFormValidators = _this.getFormValidators.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSubmitCallback = _this.handleSubmitCallback.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(AbstractFormComponent, [{
    key: "reset",
    value: function reset() {
      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.setState({
        submitted: false,
        submitting: false,
        loading: loading,
        formData: this.getFormData(),
        fieldErrors: {}
      });
      this.formValidators = this.getFormValidators();
    }
  }, {
    key: "validateAllFields",
    value: function validateAllFields() {
      var _this2 = this;

      Object.keys(this.state.formData).forEach(function (fieldName) {
        _this2.validateField(fieldName, _this2.state.formData[fieldName]);
      });
    }
  }, {
    key: "validateField",
    value: function validateField(name, value, callback) {
      var fieldValidators = this.formValidators[name];
      var fieldErrors = this.state.fieldErrors;
      var validation = (0, _validators.doValidate)(fieldValidators, value);

      if (fieldErrors[name] === validation) {
        if (callback) {
          callback();
        }

        return;
      }

      fieldErrors[name] = validation;
      this.setState({
        fieldErrors: fieldErrors
      }, function () {
        return callback ? callback() : null;
      });
    }
  }, {
    key: "isFormValid",
    value: function isFormValid() {
      return !this.isFormInvalid();
    }
  }, {
    key: "isFormInvalid",
    value: function isFormInvalid() {
      return Object.values(this.state.fieldErrors).find(function (fieldError) {
        return Boolean(fieldError);
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(name) {
      var _this3 = this;

      return function (event) {
        var formData = _this3.state.formData;
        var value = event.target.value;

        if (event.target.type === 'checkbox') {
          value = event.target.checked;
        }

        formData[name] = value;

        _this3.setState({
          formData: formData
        }, _this3.state.submitted ? function () {
          _this3.validateField(name, value, function () {
            return _this3.handleChangeCallback(name, value);
          });
        } : function () {
          return _this3.handleChangeCallback(name, value);
        });
      };
    } // eslint-disable-next-line no-unused-vars, class-methods-use-this

  }, {
    key: "handleChangeCallback",
    value: function handleChangeCallback(name, value) {}
  }, {
    key: "isOnError",
    value: function isOnError(fieldName) {
      var waitForSubmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!waitForSubmit || this.state.submitted) {
        return Boolean(this.state.fieldErrors[fieldName]);
      }

      return false;
    }
  }, {
    key: "helperText",
    value: function helperText(fieldName) {
      var waitForSubmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (waitForSubmit && !this.state.submitted) {
        return null;
      }

      var fieldError = this.state.fieldErrors[fieldName];

      if (!fieldError) {
        return null;
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: fieldError
      });
    }
  }, {
    key: "handleCancel",
    value: function handleCancel(event) {
      event.preventDefault();
      this.setState({
        formData: this.getFormData()
      }, this.validateAllFields);
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      event.preventDefault();

      if (!this.state.submitted) {
        this.validateAllFields();
      }

      this.setState({
        submitted: true
      });

      if (this.isFormInvalid()) {
        return;
      }

      var trimedData = this.trimValues(this.state.formData);
      this.setState({
        submitting: true,
        loading: true,
        formData: trimedData
      }, this.handleSubmitCallback);
    }
  }, {
    key: "trimValues",
    value: function trimValues(formData) {
      var trimedData = _objectSpread({}, formData);

      Object.entries(trimedData).forEach(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        if (typeof value === 'string') {
          trimedData[key] = value.trim();
        }
      });
      return trimedData;
    }
  }, {
    key: "getFieldLabel",
    value: function getFieldLabel(label) {
      var required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var fieldLabel = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: label
      });
      return required ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        children: [fieldLabel, " *"]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: fieldLabel
      });
    }
  }]);
  return AbstractFormComponent;
}(_react.default.Component);

var _default = AbstractFormComponent;
exports.default = _default;
//# sourceMappingURL=AbstractFormComponent.js.map